import axios from "axios";

// const AuthStr = "Bearer " + localStorage.getItem("token");
function getAuthHeader() {
  if (window.isSharedReportMode === true) {
    const copied = localStorage.getItem("share_access_token_copied");
    const email = localStorage.getItem("share_access_token_email");
    const token = copied || email;

    if (!token) return "";
    return `Bearer ${token}`;
  }

  const userToken = localStorage.getItem("token");
  return userToken ? `Bearer ${userToken}` : "";
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function getApiCall(url) {
    return axios
        .get(process.env.REACT_APP_API_KEY + url, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        })
        .then((data) => {
            return data;
        });
}

function getV2ApiCall(url) {
    return axios
        .get(process.env.REACT_APP_API_KEY2 + url, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        })
        .then((data) => {
            return data;
        });
}

function postApiCall(url, body) {
    return axios
        .post(process.env.REACT_APP_API_KEY + url, body, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone, },
        })
        .then((data) => {
            return data;
        });
}

function putApiCall(url, body) {
    return axios
        .put(process.env.REACT_APP_API_KEY + url, body, {
            headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        })
        .then((data) => {
            return data;
        });
}

function deleteApiCall(url, body) {
    return axios.delete(process.env.REACT_APP_API_KEY + url, {
        headers: { Authorization: getAuthHeader(), 'X-User-Timezone': userTimezone },
        data: body
    }).then((data) => {
        return data;
    });
}

function handle403Logout(error) {
  const status = error?.response?.status;
  const message = error?.response?.data?.message || "Session expired. Please log in again.";

  const isSharedViewer = localStorage.getItem("share_access_token_copied") || localStorage.getItem("share_access_token_email");
  if (isSharedViewer && (status === 403 || status === 401)) {
    localStorage.removeItem("share_access_token_copied");
    localStorage.removeItem("share_access_token_email");
    localStorage.removeItem("share_access_token_expiry");
    window.dispatchEvent(new Event("shared-auth-expired"));
    return;
  }

  if (status === 403 || status === 401) {
    localStorage.clear();
    alert(message);
    window.location.href = '/login';
  }
}

export { getApiCall, postApiCall, putApiCall, deleteApiCall, getV2ApiCall, handle403Logout };
